var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5C15.1869 1.5 19 5.313 19 10C19 14.687 15.1869 18.5 10.5 18.5C5.8131 18.5 2 14.687 2 10C2 5.313 5.8132 1.5 10.5 1.5ZM10.5 0C4.9772 0 0.5 4.477 0.5 10C0.5 15.523 4.9772 20 10.5 20C16.0228 20 20.5 15.5229 20.5 10C20.5 4.4771 16.023 0 10.5 0Z",
    fill: "#757676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1758 8.25989C13.8394 8.25989 14.3774 7.72191 14.3774 7.05829C14.3774 6.39466 13.8394 5.85669 13.1758 5.85669C12.5122 5.85669 11.9742 6.39466 11.9742 7.05829C11.9742 7.72191 12.5122 8.25989 13.1758 8.25989Z",
    fill: "#757676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82416 8.25977C8.48786 8.25977 9.02586 7.72187 9.02586 7.05817C9.02586 6.39447 8.48786 5.85657 7.82416 5.85657C7.16046 5.85657 6.62266 6.39467 6.62266 7.05817C6.62266 7.72167 7.16056 8.25977 7.82416 8.25977Z",
    fill: "#757676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6247 12.1308C12.8762 13.0162 11.7502 13.5761 10.5002 13.5761C9.2502 13.5761 8.124 13.0163 7.3756 12.1306C7.1497 11.8634 6.75 11.8298 6.4828 12.0555C6.2156 12.2813 6.182 12.6811 6.4078 12.9484C7.3889 14.1108 8.8674 14.8428 10.5001 14.8428C12.1328 14.8428 13.6111 14.1106 14.5923 12.9482C14.818 12.681 14.7843 12.2813 14.5171 12.0556C14.2499 11.8298 13.8503 11.8635 13.6247 12.1308Z",
    fill: "#757676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.7c4bdc447e66b0e03b6ce09e5f89ca72.svg";
export { ForwardRef as ReactComponent };